import { useRouter } from "next/navigation";
import { usePreviousPage } from "./PreviousPageContext";
import getPageLabel from "./getPageLabel";
import isTransientPath from "./isTransientPath";

/**
 * Gives a "Back to X" label and navigation handler contextual to whichever
 * page the user actually came from (label + exact URL, including any
 * search/filter/page state), falling back to a fixed default when there's
 * no known previous page (e.g. the detail page was opened via a direct URL)
 * or the previous page was a transient wizard/flow route (e.g. a float
 * creation step) that isn't a sensible place to land back on.
 */
export default function useContextualBack(fallbackPath, fallbackLabel) {
  const router = useRouter();
  const rawPreviousPath = usePreviousPage();
  const previousPath =
    rawPreviousPath && !isTransientPath(rawPreviousPath) ? rawPreviousPath : null;

  const label = previousPath ? getPageLabel(previousPath) : fallbackLabel;

  const goBack = () => {
    if (previousPath) {
      router.back();
    } else {
      router.push(fallbackPath);
    }
  };

  return { label: `Back to ${label}`, goBack };
}
